import React from 'react';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet'
import { ThemedText, ThemedView } from "@app/theme";
import Button from "@sharedComponents/Button/Button";
import gs from "@app/styles/globalStyles";
import LottieView from "lottie-react-native";
import RightArrow from "@app/assets/svg/RightArrow";
import { addCommasToNumber } from "@app/utils";

interface ConfirmStateProps {
    colors: any;
    setShowConfirmCard: (showConfirmCard: boolean) => void;
    previousSelectedState: string;
    newSelectedState: string;
    previousStampDutyAmount: string;
    newStampDutyAmount: string;
    setChangeState: (changeState: boolean) => void;
    changeStateCTALoader: boolean;
    navigation: any;
    handleStateUpdate: () => Promise<void>;
}


export const ConfirmState: React.FC<ConfirmStateProps> = ({
    colors,
    setShowConfirmCard,
    previousSelectedState,
    newSelectedState,
    previousStampDutyAmount,
    newStampDutyAmount,
    setChangeState,
    changeStateCTALoader,
    navigation,
    handleStateUpdate
}) => {
    return (
        <BottomSheetContainer
            isVisible={true}
            close={() => {
                setShowConfirmCard(false)
            }}
            showCloseIcon={true}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            showCloseIcon={true}
            dragComponent={undefined} 
            containerStyle={{
                maxHeight: 332,
            }}
        >
            <ThemedView padding={"lg"}>
                <ThemedView width={"90%"}> 
                    <ThemedText mt={"sm"} variant={"h5s"} mb={"lg"}>
                        {`Are you sure you want to change the state to ${newSelectedState}?`}
                    </ThemedText>
                </ThemedView>
               

                <ThemedView borderRadius={"sm"} padding={"md"} flexDirection={"row"} justifyContent={"space-between"}
                    mb={"lg"} alignItems={"center"} width={"100%"} backgroundColor={"bg-surface-secondary"}>
                    <ThemedView flex={1}>
                        <ThemedText mb={"sm"} variant={"b4m"} color={"text-secondary"}>
                            Previous selection
                        </ThemedText>
                        <ThemedView width={"100%"} padding={"md"} borderRadius={"sm"} borderWidth={1}
                            borderColor={"border-primary"}
                            backgroundColor={"white"}>
                            <ThemedText variant={"b4r"}>
                                {previousSelectedState}
                            </ThemedText>
                            <ThemedText mt={"xs"} variant={"b3s"} color={"text-primary"} alignItems={"center"}>
                                {`₹${addCommasToNumber(Number(previousStampDutyAmount))}`}
                            </ThemedText>

                        </ThemedView>
                    </ThemedView>

                    <ThemedView alignItems={"center"} alignSelf={"center"} mt={"xl"} marginHorizontal={"md"}>
                        <RightArrow />
                    </ThemedView>

                    <ThemedView flex={1}>
                        <ThemedText mb={"sm"} variant={"b4m"} color={"text-primary"}>
                            Current selection
                        </ThemedText>
                        <ThemedView padding={"md"} borderRadius={"sm"} borderWidth={1} borderColor={"border-action"}
                            backgroundColor={"bg-fill-emphasis-primary-1"}>
                            <ThemedText variant={"b4r"}>
                                {newSelectedState}
                            </ThemedText>
                            <ThemedText mt={"xs"} variant={"b3s"} color={"text-primary"} alignItems={"center"}>
                                {`₹${addCommasToNumber(Number(newStampDutyAmount))}`}
                            </ThemedText>

                        </ThemedView>
                    </ThemedView>

                </ThemedView>

                <Button
                    label="Don't change the state"
                    type="SOLID"
                    size='MD'
                    disabled={false}
                    handlePress={() => {
                        setShowConfirmCard(false)
                        navigation.goBack();
                    }}
                    bg={colors['bg-action-primary']}
                    textColor={colors['text-primary']}
                />

                <ThemedView mt={"lg"} width={"100%"}>
                    <Button
                        label="Confirm and proceed"
                        type="OUTLINED"
                        size='MD'
                        disabled={false}
                        handlePress={ async () => {
                            setChangeState(true)
                            await handleStateUpdate()
                            navigation.replace('PLEDGE_CONFIRMATION', {hasStateChanged: true})
                        }}
                        textColor={colors['text-primary']}
                        buttonLoader={changeStateCTALoader}
                    />
                </ThemedView>


            </ThemedView>
        </BottomSheetContainer>
    );
};